import { Link } from '@tanstack/react-router'
import { Avatar, AvatarFallback, AvatarImage } from '@workspace/ui/components/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@workspace/ui/components/dropdown-menu'
import { getInitials } from '@workspace/ui/lib/utils'
import { LogOut, Settings, User } from 'lucide-react'
import { useIsAdmin } from '@/hooks/use-user-type'
import { auth } from '@/lib/auth'

export function NavUser({
  user,
}: {
  user: {
    name: string
    email: string
    avatar: string
  }
}) {
  const isAdmin = useIsAdmin()

  const handleSignOut = async () => {
    await auth.signOut()
    window.location.href = '/'
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="group flex items-center gap-2 rounded-lg p-1.5 text-left text-sm opacity-80 hover:opacity-100 transition-opacity outline-none cursor-default"
        >
          <span className="truncate font-medium max-w-32">{user.name}</span>
          <Avatar className="h-7 w-7 rounded-full ring-2 ring-transparent group-hover:ring-[#f97316]/60 transition-all">
            <AvatarImage src={user.avatar} alt={user.name} />
            <AvatarFallback className="rounded-full text-xs">
              {getInitials(user.name)}
            </AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-40 rounded-lg" align="end" sideOffset={8}>
        {isAdmin && (
          <>
            <DropdownMenuItem asChild>
              <Link to="/admin/evaluations">
                <Settings />
                Admin
              </Link>
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem asChild>
          <Link to="/profile">
            <User />
            Profile
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={handleSignOut}
          className="text-red-500 focus:text-red-500 focus:bg-red-500/10"
        >
          <LogOut className="text-red-500" />
          Sign Out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
